import React from 'react';
import Styles from './mascot-render-styles.scss';
const Mascot = ({ type = 'fistPumBull', width = '250px', height = '350px' }) => (React.createElement("div", { "data-testid": "loading", className: Styles.mascotContainer },
    React.createElement("img", { className: Styles[type], style: { height: height, width: width } })));
export default Mascot;
